export default __webpack_public_path__ + "6e65270e388229c5c23e6f40a8fd5053.png";